CostesActionsService.$inject = ['$log', 'dialogService'];

export default function CostesActionsService($log, dialogService) {

    var TAG = 'CostesActionsService: ';

    var DIALOG_EDIT_COSTES_TEMPLATE = require('./costes-edit-modal/costes-edit-modal.html');
    var DIALOG_EDIT_COSTES_ID = 'dialog-edit-costes';

    return {
        dialogEditCostes: __dialogEditCostes
    };

    function __dialogEditCostes(costes, tareaId) {
        var titulo = ucfirst(Lang.choice('nombres.editar', 1)) + ' ' + costes.name;

        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 600
        };
        var opcionesExtra = {deshabilitarBotones: true, devolverDatos: true};
        var params = {
            costes: costes,
            tareaId: tareaId
        };

        return dialogService.open(DIALOG_EDIT_COSTES_ID, DIALOG_EDIT_COSTES_TEMPLATE, params, options, opcionesExtra)
    }
}